module.exports = "data:font/woff;base64,"